import { SubscriptionCategory } from '../../common/enums.js';
import { BroadbandSubscriptionLayout } from './BroadbandSubscriptionLayout.js';
import { VoiceSubscriptionLayout } from './VoiceSubscriptionLayout.js';

export const getMobileSubscriptionLayout = (subscriptionCategory?: SubscriptionCategory) =>
  subscriptionCategory === SubscriptionCategory.VOICE ? VoiceSubscriptionLayout : BroadbandSubscriptionLayout;
